import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AerialBorneShorts.scss";

import shots from "./shots.js";

const AerialBorneShorts = () => {
  const [activeTab, setActiveTab] = useState("flyingTips");
  const [expanded, setExpanded] = useState(false);

  const navigate = useNavigate();

  const handleClick = (index, idx) => {
    navigate(`country-shots/${index}/${idx}`);
  };

  const content = {
    flyingTips: `At AerialBorne, responsible drone operation is a top priority. Our guide to drone laws and battery transportation policies helps you navigate the complexities of regulations in 20+ popular destinations. Fly safely, legally, and with confidence.`,
    industryUpdates: `Stay informed with the latest industry news, regulatory changes, and technological advancements in the drone industry. We provide updates on global drone policies, emerging trends, and insights from industry experts.`,
  };

  return (
    <div className="aerial-borne-container">
      <h2 className="title">Aerial Borne Shorts</h2>
      <div className="tabs">
        <span
          className={`tab ${activeTab === "flyingTips" ? "active" : ""}`}
          onClick={() => setActiveTab("flyingTips")}
        >
          Flying Tips
        </span>
        <span
          className={`tab ${activeTab === "industryUpdates" ? "active" : ""}`}
          onClick={() => setActiveTab("industryUpdates")}
        >
          Industry Updates
        </span>
      </div>

      {/* Wrapping content and button in a flex container to align them */}
      <div className="content-container">
        <p className="content">{content[activeTab]}</p>
        <button className="expand-button" onClick={() => setExpanded(!expanded)}>
          {expanded ? "Collapse ▲" : "Expand ▼"}
        </button>
      </div>

      {expanded && (
        <div className="country-grid">
          {shots.map((continent, index) => (
            <div key={index} className="continent-section">
              <h2 className="continent-title">{continent.continent}</h2>
              <div className="countries">
                {continent.countries.map((countryData, idx) => (
                  <div
                    key={idx}
                    className="country-card"
                    onClick={() => handleClick(index, idx)}
                    style={{ backgroundImage: `url(${countryData.src})` }}
                  >
                    <div className="overlay">
                      <span className="country-name">{countryData.country}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AerialBorneShorts;
